import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Skeleton, Card, CardContent, Grid, Stack } from '@mui/material';
import axios from '../api/axiosConfig';
import TourBookingDetails from './TourBookingDetails';
import RentalBookingDetails from './RentalBookingDetails';
import BikeTravelBookingDetails from './BikeTravelBookingDetails';

function BookingDetailsSkeleton() {
    return (
        <Container maxWidth="lg" sx={{ py: 6 }}>
            <Skeleton variant="rounded" width="100%" height={52} sx={{ borderRadius: '12px', mb: 4 }} />
            <Grid container spacing={3} alignItems="flex-start">
                {[1, 2, 3].map(i => (
                    <Grid key={i} item xs={12} md={4}>
                        <Card elevation={2}>
                            <CardContent sx={{ p: 3 }}>
                                <Skeleton variant="text" width="70%" height={28} sx={{ mb: 2 }} />
                                <Stack spacing={1.5}>
                                    {Array.from({ length: 4 }).map((_, j) => (
                                        <Skeleton key={j} variant="text" width="100%" height={18} />
                                    ))}
                                </Stack>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
}

const BookingDetails = () => {
    const { id } = useParams();
    const [bookingType, setBookingType] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios.get(`/bills/view/id/${id}`)
            .then(({ data }) => {
                const type = data.billType === 'BIKE_TRAVEL' ? 'BIKE_TRAVEL'
                           : data.billType === 'RENTAL'      ? 'RENTAL'
                           : 'TOUR';
                setBookingType(type);
            })
            .catch(() => setBookingType('TOUR'))
            .finally(() => setLoading(false));
    }, [id]);

    if (loading) return <BookingDetailsSkeleton />;

    switch (bookingType) {
        case 'RENTAL':      return <RentalBookingDetails />;
        case 'BIKE_TRAVEL': return <BikeTravelBookingDetails />;
        default:            return <TourBookingDetails />;
    }
};

export default BookingDetails;
